import React, { Component } from 'react';
import ErrorMessage from '../common/ErrorMessage';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import poweredLogo from '../../img/powered-by-logo.png';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';

const styles = {
  main: {
    maxWidth: '400px',
    minWidth: '250px',
  },
  paper: {
    marginTop: '50px',
    padding: '60px 30px ',
  },
  button: {
    margin: '30px 10px',
    display: 'inline-block',
  },
  bottom: {
    marginTop: '20px',
  },
  section: {
    marginTop: '10px',
  },
  header: {
    marginBottom: '0px',
  },
  paragraph: {
    margin: '10px 0',
  },
};

class Forgot extends Component {
  renderErrors(errors) {
    if (errors) {
      if (Array.isArray(errors)) {
        return errors.map((error, i) => <ErrorMessage key={i} error={error} />);
      } else {
        return <ErrorMessage error={errors} />;
      }
    }
  }

  render() {
    const {
      errors,
      currentlySending,
      loading,
      handleSubmit,
      handlePasswordChange,
      handlePasswordConfirmationChange,
      handleMfaCodeChange,
      password,
      errorPassword,
      passwordConfirmation,
      errorPasswordConfirmation,
      mfaCode,
      errorMfaCode,
      logo,
    } = this.props;

    return (
      <div className="col-xs-10 col-sm-6 col-md-4 col-lg-4" style={styles.main}>
        <div className="box">
          <Paper elevation={3} style={styles.paper}>
            <form action="#" method="POST" onSubmit={handleSubmit}>
              <div className="row center-xs">
                <div className="col-xs-12">
                  <div className="box">{logo()}</div>
                </div>
                <div className="col-sm-10 col-xs-11">
                  <div className="box">
                    <h2 style={styles.header}>Enter Verification Code</h2>
                    <p style={styles.paragraph}>Enter the SMS code sent to your mobile device</p>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    {currentlySending || loading ? (
                      <CircularProgress size={25} thickness={5} />
                    ) : (
                      this.renderErrors(errors)
                    )}
                  </div>
                </div>
                <div className="col-sm-10 col-xs-11">
                  <div className="box">
                    <FormControl
                      fullWidth
                      error={errorMfaCode ? true : false}
                      aria-describedby="mfa"
                    >
                      <InputLabel shrink htmlFor="mfa-label">
                        Verification Code
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="mfa"
                        value={mfaCode}
                        onChange={handleMfaCodeChange}
                      />
                      <FormHelperText id="username-error-text">{errorMfaCode}</FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-sm-10 col-xs-11" style={styles.section}>
                  <div className="box">
                    <h2 style={styles.header}>Enter New Password</h2>
                    <p style={styles.paragraph}>Enter your new password and confirm it</p>
                  </div>
                </div>
                <div className="col-sm-10 col-xs-11">
                  <div className="box" style={{ margin: '10px 0 10px' }}>
                    <FormControl
                      fullWidth
                      error={errorPassword ? true : false}
                      aria-describedby="new-password"
                    >
                      <InputLabel shrink htmlFor="new-password-label">
                        New Password
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="new-password"
                        value={password}
                        onChange={handlePasswordChange}
                        type="password"
                      />
                      <FormHelperText id="password-error-text">{errorPassword}</FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-sm-10 col-xs-11">
                  <div className="box">
                    <FormControl
                      fullWidth
                      error={errorPasswordConfirmation ? true : false}
                      aria-describedby="password-confirmation"
                    >
                      <InputLabel shrink htmlFor="password-confirmation-label">
                        Confirm Password
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="password-confirmation"
                        value={passwordConfirmation}
                        onChange={handlePasswordConfirmationChange}
                        type="password"
                      />
                      <FormHelperText id="password-error-text">
                        {errorPasswordConfirmation}
                      </FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    <Button
                      variant="contained"
                      type="submit"
                      id="submit-button"
                      style={styles.button}
                      color="primary"
                      disabled={currentlySending || loading ? true : false}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          </Paper>
          <a href="http://defisolutions.com" target="_blank" rel="noopener noreferrer">
            <img src={poweredLogo} style={styles.bottom} alt="logo" />
          </a>
        </div>
      </div>
    );
  }
}

export default Forgot;
